var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 40,
    viewBox: "0 0 156 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.662 29.0141V33.1493H49.5099V6.8507H53.6451V29.0141H71.662Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.49 20L155.639 33.1493H149.792L139.572 22.9296L137.623 24.8789V33.1493H133.487V6.8507H137.623V19.0197L149.792 6.8507H155.639L142.49 20Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0394 6.8507V26.9296L95.9549 29.0141H82.0958L80.0113 26.9296V6.8507H75.8761V28.6423L80.3831 33.1493H97.6676L102.175 28.6423V6.8507H98.0394Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.901 29.0141H112.969L110.885 26.9296V13.0704L112.969 10.9859H128.901V6.8507H111.256L106.749 11.3577V28.6423L111.256 33.1493H128.901V29.0141Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6732 22.231L32.9577 20L31.6732 17.769L37.4986 16.2141L40.0113 6.8507L33.1493 0L23.7859 2.51268L22.231 8.33803L20 7.05352L17.769 8.33803L16.2141 2.51268L6.8507 0L0 6.8507L2.51268 16.2141L8.33803 17.769L7.05352 20L8.33803 22.231L2.51268 23.7859L0 33.1493L6.8507 40L16.2141 37.4873L17.769 31.662L20 32.9465L22.231 31.662L23.7859 37.4873L33.1493 40L40 33.1493L37.4873 23.7859L31.662 22.231H31.6732ZM32.3042 36.8451L26.0958 35.1775L24 27.369L20 29.6789L16 27.369L13.9042 35.1775L7.69578 36.8451L3.15493 32.3042L4.82254 26.0958L12.631 24.0113L10.3211 20.0113L12.631 16.0113L4.82254 13.9155L3.15493 7.70704L7.69578 3.15493L13.9042 4.82254L16 12.631L20 10.3211L24 12.631L26.0958 4.82254L32.3042 3.15493L36.8451 7.69578L35.1775 13.9042L27.369 16L29.6789 20L27.369 24L35.1775 26.0845L36.8451 32.293L32.3042 36.8338V36.8451Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.0873L23.1099 16.8901L24.9127 20L23.1099 23.1211L20 24.9127L16.8901 23.1211L15.0873 20L16.8901 16.8901L20 15.0873Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bae3d41baa73f1412758dada0a071e8.svg";
export { ForwardRef as ReactComponent };